var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 527,
    viewBox: "0 0 1728 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650.653 73.0282C324.281 -93.0535 5.86499 70.9715 -155.336 107.724C-159.02 108.564 -161.535 111.791 -161.535 115.569V319.835C-161.535 324.505 -157.552 328.182 -152.898 327.81L769.838 254.05C770.255 254.017 770.674 254.016 771.092 254.048L1727.78 327.91C1732.05 328.24 1735.83 325.143 1736.34 320.887L1755.25 163.255C1755.86 158.221 1751.53 153.915 1746.48 154.344C1175.85 202.818 956.653 228.743 650.653 73.0282Z",
    fill: "#22114F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M998.195 453.472C1324.18 619.357 1642.23 455.917 1803.61 418.907C1807.55 418.005 1810.12 414.389 1809.78 410.366L1798.51 279.751C1798.17 275.855 1795.07 272.773 1791.17 272.464L-69.4428 124.686C-74.0961 124.316 -78.0762 127.993 -78.0762 132.661V374.793C-78.0762 379.478 -73.8496 383.142 -69.1823 382.736C500.104 333.177 514.969 207.571 998.195 453.472Z",
    fill: "#22114F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqCurve);
export default __webpack_public_path__ + "static/media/faqCurve.8f89598123160c34afc78ba200aca415.svg";
export { ForwardRef as ReactComponent };